import { truncateRevenueCatAttributeValue } from "./attribution-attributes";

type CheckoutSubscriberAttributeInput = {
  email?: string | null;
  posthogUserId?: string | null;
  couponCode?: string | null;
};

export function buildCheckoutSubscriberAttributes({
  email,
  posthogUserId,
  couponCode,
}: CheckoutSubscriberAttributeInput): Record<string, string> {
  const attributes: Record<string, string> = {};
  const setAttribute = (key: string, value?: string | null) => {
    const normalizedValue = truncateRevenueCatAttributeValue(value?.trim());
    if (normalizedValue) attributes[key] = normalizedValue;
  };

  setAttribute("$email", email);
  setAttribute("$posthogUserId", posthogUserId);
  setAttribute("coupon_used", couponCode?.toLowerCase());

  return attributes;
}
